import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.58877 0 0 3.58832 0 7.999C0 12.4117 3.58877 16 8 16C12.4112 16 16 12.4117 16 8.001C16 3.59032 12.4112 0 8 0ZM8 13.7435C7.15747 13.7435 6.47342 13.0595 6.47342 12.2171C6.47342 11.3747 7.15747 10.6907 8 10.6907C8.84253 10.6907 9.52658 11.3747 9.52658 12.2171C9.52658 13.0616 8.84253 13.7435 8 13.7435ZM8 9.85634C6.98295 9.85634 6.1665 5.10267 6.1665 4.09176C6.1665 3.07885 6.98897 2.25849 8.00201 2.25849C9.01505 2.25849 9.83551 3.07885 9.83551 4.09176C9.8335 5.10267 9.01705 9.85634 8 9.85634Z"
      fill="#F3A126"
    />
  </svg>
);

export default SVGComponent;
